import Vue from 'vue';
import * as EvergreenComponents from '@/components/evergreen';
import * as MapComponents from '@/components/map';

/**
 * Adds components to the Vue instance
*/
function installCustomComponents(components) {
	Object.keys(components).forEach(name => {
		Vue.component(name, components[name]);
	});
}

export default function() {
	installCustomComponents(EvergreenComponents);
	installCustomComponents(MapComponents);
}

